import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BottomNav from "../components/BottomNav";
import InternalHeader from "../components/InternalHeader";
import { api } from "../lib/api";
import { useLocale } from "../context/Locale";

export default function PagesIndex() {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { t } = useLocale();

  useEffect(() => {
    api("/get-pages", { method: "POST", body: "{}" })
      .then((response) => setPages(Array.isArray(response) ? response : []))
      .catch((requestError) => setError(requestError.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <main className="food-app">
      <InternalHeader title={t("infoTitle")} backTo="/account" />
      <div className="pages-index">
        {loading && <div className="food-message"><b>Cargando información…</b></div>}
        {error && <div className="food-message food-message--error"><b>{error}</b></div>}
        <section>
          {pages.map((page) => (
            <Link key={page.id} to={`/pages/${page.slug}`}>
              <span>📄</span><b>{page.name || page.title}</b><em>›</em>
            </Link>
          ))}
        </section>
      </div>
      <BottomNav />
    </main>
  );
}
